// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/icing-avoidance.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/icing-avoidance/icing-avoidance.js';

mount([g0]);
